// import styles from "../Styles/Filter.module.scss";
// import { useNavigate} from "react-router-dom";
// import { useContext} from "react";
// import { MainContext } from "../../App";

// function Filter() {
//   const context = useContext(MainContext);
//   const {
//     searchByCity,
//     setSearchByCity,
//     searchByProfession,
//     setSearchByProfession,
//     setTitleForCategory,
//     scrolled,
//   } = context;
//   const navigate = useNavigate();

//   const filterHandler = () => {
//     setTitleForCategory("");
//     navigate(`/filter`);
//   };

//   return (
//     <>
//       <div className={`${styles.parentContainer} ${scrolled ? styles.scrolled : ""}`}>
//         <div className={styles.filter}>
//           <div className={styles.selectContainer}>
//             <select
//               name="selectedCity"
//               id="city"
//               className={styles.selectContainer__select}
//               value={searchByCity}
//               onChange={(e) => setSearchByCity(e.target.value)}
//             >
//               <option value="">ქალაქი</option>
//               <option value="თბილისი">თბილისი</option>
//               <option value="ბათუმი">ბათუმი</option>
//               <option value="რუსთავი">რუსთავი</option>
//               <option value="გორი">გორი</option>
//               <option value="ქუთაისი">ქუთაისი</option>
//             </select>
//           </div>

//           <div className={styles.selectContainer}>
//             <select
//               name="selectedProfession"
//               id="profession"
//               className={styles.selectContainer__select}
//               value={searchByProfession}
//               onChange={(e) => setSearchByProfession(e.target.value)}
//             >
//               <option value="">კატეგორია</option>
//               <option value="მღებავი (მალიარი)">მღებავი (მალიარი)</option>
//               <option value="კაფელ-მეტლახის ხელოსანი">
//                 კაფელ-მეტლახის ხელოსანი
//               </option>
//               <option value="ელექტრიკოსი">ელექტრიკოსი</option>
//               <option value="სანტექნიკი">სანტექნიკი</option>
//               <option value="არქიტექტორი">არქიტექტორი</option>
//               <option value="მშენებელი">მშენებელი</option>
//               <option value="სამშენებლო სპეც-ტექნიკა">
//                 სამშენებლო სპეც-ტექნიკა
//               </option>
//               <option value="მეტალო პლასტმასის ხელოსანი">
//                 მეტალო პლასტმასის ხელოსანი
//               </option>
//               <option value="თაბაშირ-მუყაოს ხელოსანი">
//                 თაბაშირ-მუყაოს ხელოსანი
//               </option>
//               <option value="გათბობა-გაგრილების სისტემა">
//                 გათბობა-გაგრილების სისტემა
//               </option>
//               <option value="სახლის დალაგება">სახლის დალაგება</option>
//               <option value="იატაკის ხელოსანი">იატაკის ხელოსანი</option>
//               <option value="კარის ხელოსანი">კარის ხელოსანი</option>
//               <option value="ავეჯის ხელოსანი">ავეჯის ხელოსანი</option>
//               <option value="სახურავის სპეციალისტი">
//                 სახურავის სპეციალისტი
//               </option>
//               <option value="უნივერსალური ხელოსანი">
//                 უნივერსალური ხელოსანი
//               </option>
//               <option value="ელ-შემდუღებელი">ელ-შემდუღებელი</option>
//               <option value="დამხმარე(მუშა)">დამხმარე(მუშა)</option>
//               <option value="დემონტაჟის სამუშაოები">
//                 დემონტაჟის სამუშაოები
//               </option>
//               <option value="სარეცხი მანქანის ხელოსანი">
//                 სარეცხი მანქანის ხელოსანი
//               </option>
//               <option value="ჭერის სამუშაოები">ჭერის სამუშაოები</option>
//               <option value="ლესვა">ლესვა</option>
//               <option value="ბლოკის წყობა">ბლოკის წყობა</option>
//               <option value="შუშის (მინის) სამუშაოები">
//                 შუშის (მინის) სამუშაოები
//               </option>
//               <option value="ალპინისტური სამუშაოები">
//                 ალპინისტური სამუშაოები
//               </option>
//               <option value="ინტერიერის დიზაინერი">ინტერიერის დიზაინერი</option>
//             </select>
//           </div>
//           <button className={styles.button} onClick={filterHandler}>
//             ძებნა
//           </button>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Filter;

///////////////////

import styles from "../Styles/Filter.module.scss";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { MainContext } from "../../App";

function Filter() {
  const context = useContext(MainContext);
  const {
    searchByCity,
    setSearchByCity,
    searchByProfession,
    setSearchByProfession,
    setTitleForCategory,
    scrolled,
  } = context;
  const navigate = useNavigate();

  const filterHandler = () => {
    setTitleForCategory("");
    navigate(`/filter`);
  };

  return (
    <>
      <div
        className={`${styles.parentContainer} ${
          scrolled ? styles.scrolled : ""
        }`}
      >
        <div className={styles.filter}>
          <div className={styles.selectContainer}>
            <select
              name="selectedCity"
              id="city"
              className={styles.selectContainer__select}
              value={searchByCity}
              onChange={(e) => setSearchByCity(e.target.value)}
            >
              <option value="">ქალაქი</option>
              <option value="თბილისი">თბილისი</option>
              <option value="ბათუმი">ბათუმი</option>
              <option value="რუსთავი">რუსთავი</option>
              <option value="გორი">გორი</option>
              <option value="ქუთაისი">ქუთაისი</option>

              <option value="აბაშა">აბაშა</option>
              <option value="ადიგენი">ადიგენი</option>
              <option value="ასპინძა">ასპინძა</option>
              <option value="ახალქალაქი">ახალქალაქი</option>
              <option value="ახალციხე">ახალციხე</option>
              <option value="ბაღდათი">ბაღდათი</option>
              <option value="ბოლნისი">ბოლნისი</option>
              <option value="ბორჯომი">ბორჯომი</option>
              <option value="გურჯაანი">გურჯაანი</option>
              <option value="დედოფლისწყარო">დედოფლისწყარო</option>
              <option value="დმანისი">დმანისი</option>
              <option value="დუშეთი">დუშეთი</option>
              <option value="ვანი">ვანი</option>
              <option value="ზესტაფონი">ზესტაფონი</option>
              <option value="ზუგდიდი">ზუგდიდი</option>
              <option value="თეთრიწყარო">თეთრიწყარო</option>
              <option value="თელავი">თელავი</option>
              <option value="თერჯოლა">თერჯოლა</option>
              <option value="თიანეთი">თიანეთი</option>
              <option value="ლაგოდეხი">ლაგოდეხი</option>
              <option value="ლანჩხუთი">ლანჩხუთი</option>
              <option value="მარნეული">მარნეული</option>
              <option value="მარტვილი">მარტვილი</option>
              <option value="მესტია">მესტია</option>
              <option value="მცხეთა">მცხეთა</option>
              <option value="ოზურგეთი">ოზურგეთი</option>
              <option value="საგარეჯო">საგარეჯო</option>
              <option value="სამტრედია">სამტრედია</option>
              <option value="საჩხერე">საჩხერე</option>
              <option value="სენაკი">სენაკი</option>
              <option value="სიღნაღი">სიღნაღი</option>
              <option value="ტყიბული">ტყიბული</option>
              <option value="ქარელი">ქარელი</option>
              <option value="ქობულეთი">ქობულეთი</option>
              <option value="ყვარელი">ყვარელი</option>
              <option value="ხარაგაული">ხარაგაული</option>
              <option value="ხაშური">ხაშური</option>
              <option value="ხობი">ხობი</option>
              <option value="ჩოხატაური">ჩოხატაური</option>
              <option value="ცაგერი">ცაგერი</option>
              <option value="ჭიათურა">ჭიათურა</option>
            </select>
          </div>

          <div className={styles.selectContainer}>
            <select
              name="selectedProfession"
              id="profession"
              className={styles.selectContainer__select}
              value={searchByProfession}
              onChange={(e) => setSearchByProfession(e.target.value)}
            >
              <option value="">კატეგორია</option>
              <option value="მღებავი (მალიარი)">მღებავი (მალიარი)</option>
              <option value="კაფელ-მეტლახის ხელოსანი">
                კაფელ-მეტლახის ხელოსანი
              </option>
              <option value="ელექტრიკოსი">ელექტრიკოსი</option>
              <option value="სანტექნიკი">სანტექნიკი</option>
              <option value="არქიტექტორი">არქიტექტორი</option>
              <option value="მშენებელი">მშენებელი</option>
              <option value="სამშენებლო სპეც-ტექნიკა">
                სამშენებლო სპეც-ტექნიკა
              </option>
              <option value="მეტალო პლასტმასის ხელოსანი">
                მეტალო პლასტმასის ხელოსანი
              </option>
              <option value="თაბაშირ-მუყაოს ხელოსანი">
                თაბაშირ-მუყაოს ხელოსანი
              </option>
              <option value="გათბობა-გაგრილების სისტემა">
                გათბობა-გაგრილების სისტემა
              </option>
              <option value="სახლის დალაგება">სახლის დალაგება</option>
              <option value="იატაკის ხელოსანი">იატაკის ხელოსანი</option>
              <option value="კარის ხელოსანი">კარის ხელოსანი</option>
              <option value="ავეჯის ხელოსანი">ავეჯის ხელოსანი</option>
              <option value="სახურავის სპეციალისტი">
                სახურავის სპეციალისტი
              </option>
              <option value="უნივერსალური ხელოსანი">
                უნივერსალური ხელოსანი
              </option>
              <option value="ელ-შემდუღებელი">ელ-შემდუღებელი</option>
              <option value="დამხმარე(მუშა)">დამხმარე(მუშა)</option>
              <option value="დემონტაჟის სამუშაოები">
                დემონტაჟის სამუშაოები
              </option>
              <option value="სარეცხი მანქანის ხელოსანი">
                სარეცხი მანქანის ხელოსანი
              </option>
              <option value="ჭერის სამუშაოები">ჭერის სამუშაოები</option>
              <option value="ლესვა">ლესვა</option>
              <option value="ბლოკის წყობა">ბლოკის წყობა</option>
              <option value="შუშის (მინის) სამუშაოები">
                შუშის (მინის) სამუშაოები
              </option>
              <option value="ალპინისტური სამუშაოები">
                ალპინისტური სამუშაოები
              </option>
              <option value="ინტერიერის დიზაინერი">ინტერიერის დიზაინერი</option>
              <option value="ტვირთის გადაზიდვა">ტვირთის გადაზიდვა</option>
              <option value="ბაღის სამუშაოები">ბაღის სამუშაოები</option>
            </select>
          </div>
          <button className={styles.button} onClick={filterHandler}>
            ძებნა
          </button>
        </div>
      </div>
    </>
  );
}

export default Filter;
